// services/axiosConfig.js
import axios from 'axios';
import { getAuthToken, removeAuthToken } from '../../utils/auth';
import { toast } from 'react-toastify'; // Optional: For user notifications

const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add global response interceptor
api.interceptors.response.use(
  (response) => response, // Pass successful responses through
  (error) => {
    const status = error.response?.status;

    console.log("status: ", status)
    if (status === 400) {
      // Handle 400 Bad Request
      console.error('Bad Request:', error.response?.data?.message || error.message);
      toast.warning(error.response?.data?.message || 'Bad Request. Please check your input.');
    } else if (status === 401) {
      // Handle 401 Unauthorized (e.g., Token Expired)
      console.error('Unauthorized: Redirecting to login...');
      toast.error('Your session has expired. Please log in again.');
      removeAuthToken();
      window.location.href = '/login'; // Redirect to login page
    } else {
      toast.error(error.response?.data?.message || "Something went wrong.");
    }

    return Promise.reject(error); // Propagate the error for specific handling elsewhere
  }
);

export default api;